import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import client from "../api/client";

function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const token = searchParams.get("token");

  if (!token) {
    return (
      <main className="AuthPage" style={{ maxWidth: "480px", margin: "0 auto" }}>
        <h1>Invalid Link</h1>
        <p style={{ opacity: 0.7 }}>This password reset link is invalid or has expired.</p>
      </main>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (password !== confirmPassword) {
      return setError("Passwords do not match.");
    }

    if (password.length < 8) {
      return setError("Password must be at least 8 characters.");
    }

    setIsSubmitting(true);

    try {
      await client.post("/reset-password", { token, password });
      setSuccess(true);
      navigate("/login", { state: { message: "Password reset successfully! Please log in." } });
    } catch (err) {
      if (err.response?.status === 400) {
        setError("This reset link is invalid or has expired. Please request a new one.");
      } else {
        setError("Something went wrong. Please try again.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="AuthPage" style={{ maxWidth: "480px", margin: "0 auto" }}>
      <h1>Reset Password</h1>
      <p style={{ opacity: 0.85, marginBottom: "24px" }}>
        Enter your new password below.
      </p>

      {error && <p className="error">{error}</p>}

      <form onSubmit={handleSubmit}>
        <label>
          New Password
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>

        <label>
          Confirm New Password
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </label>

        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Resetting..." : "Reset Password"}
        </button>
      </form>
    </main>
  );
}

export default ResetPasswordPage;